import React, { FC } from 'react';

import { useFormikContext } from 'formik';

import { TableFilterConfig } from '../../ag-table/types';

import { SearchableSelectType } from '../../inputs/searchableSelect';
import FilterSelect from './FilterSelect';

interface MultiSelectFilterProps {
    onChange: (item: TableFilterConfig, value: SearchableSelectType[]) => void;
    item: TableFilterConfig;
}

const MultiSelectFilter: FC<MultiSelectFilterProps> = ({ onChange, item }) => {
    const { values, setFieldValue } = useFormikContext();

    return (
        <FilterSelect
            title={item.label}
            values={values as any}
            setFieldValue={setFieldValue}
            name={item.field}
            options={item.meta?.options ?? []}
            onChange={(value) => {
                onChange?.(item, value as SearchableSelectType[]);
            }}
        />
    );
};

export default MultiSelectFilter;
